import { IConsultaPrevaiResponse } from "../../interfaces/IBCI";
import { ILayers } from "../../interfaces/ILayers";
import { IPaginateApiResponse } from "../../interfaces/IPaginate";
import {
    AlvaraDeObra,
    ConclusaoObra,
    IGrpZoneamento,
    IProperty,
} from "../../interfaces/IProperties";
import { semvApi } from "../axios/apis.service";

export const GuiaAmarelaApiService = {
    async listProperties(
        query: string,
        relations?: string[]
    ): Promise<IPaginateApiResponse<IProperty[]>> {
        const { data: properties } = await semvApi.get(
            `/guia-amarela/busca?${query}&relations=${relations?.join(",")}`
        );

        return properties;
    },
    async getLayers(
        searchParms?: string,
        relations?: string
    ): Promise<IPaginateApiResponse<ILayers[]>> {
        const { data } = await semvApi
            .get(`/guia-amarela/layers?${searchParms}${relations}`)
            .catch(() => ({ data: { data: [] } }));

        return data;
    },
    async getPropertyConsultaPrevia(
        subscription: string
    ): Promise<
        Pick<
            IConsultaPrevaiResponse,
            "layers" | "property" | "geom" | "cnaes" | "alvara"
        >
    > {
        const { data } = await semvApi.get(`/guia-amarela/${subscription}`);

        return data;
    },

    async getPropertyAlvara(subscription: string): Promise<AlvaraDeObra> {
        const { data } = await semvApi.get(
            `/properties/${subscription}/alvara-obra`
        );

        return data;
    },

    async getPropertyCvco(subscription: string): Promise<ConclusaoObra> {
        const { data } = await semvApi.get(
            `/properties/${subscription}/conclusao-obra`
        );

        return data;
    },

    async getZoneamento(zoneamento?: string): Promise<IGrpZoneamento> {
        const { data } = await semvApi.get(
            `/guia-amarela/${zoneamento}/zoneamento`
        );
        return data;
    },
};
